export const permissions = [
  {
    url: "/home/appointment",
    module: "Appointment",
    name: "Appointment",
  },

  {
    url: "/home/patients-overview",
    module: "PATIENT",
    name: "Patient Overview",
  },
  {
    url: "/home/patient/registration",
    module: "PATIENT",
    name: "Patient Registration",
  },
  {
    url: "/home/admission",
    module: "PATIENT",
    name: "Admission",
  },
  {
    url: "/home/emergency-patient",
    module: "PATIENT",
    name: "Emergency",
  },

  {
    url: "/home/patient-discharge-summary",
    module: "PATIENT",
    name: "Patient Discharge Summary",
  },
  {
    url: "/home/emergency-patient-registration",
    module: "PATIENT",
    name: "Emergency Patient Registration",
  },
  {
    url: "/home/departments",
    module: "DEPARTMENT",
    name: "Department Overview",
  },
  {
    url: "/home/ward-overview",
    module: "DEPARTMENT",
    name: "Ward Overview",
  },
  {
    url: "/home/unit-overview",
    module: "DEPARTMENT",
    name: "Unit Overview",
  },
  {
    url: "/home/clinic-overview",
    module: "DEPARTMENT",
    name: "Clinic Overview",
  },
  {
    url: "/home/all-staffs",
    module: "STAFF",
    name: "Staff Overview",
  },
  {
    url: "/home/staff/registration",
    module: "STAFF",
    name: "Staff Registration",
  },
  {
    url: "/home/staff-shift",
    module: "STAFF",
    name: "Staff Shift",
  },
  {
    url: "/home/staff/wards",
    module: "STAFF",
    name: "Staff Wards",
  },
  {
    url: "/home/laboratory-overview",
    module: "LABORATORY",
    name: "Lab Overview",
  },
  {
    url: "/home/laboratory-stock-management",
    module: "LABORATORY",
    name: "Lab Stock Mangement",
  },
  {
    url: "/home/laboratory-test-center",
    module: "LABORATORY",
    name: "Lab Test Center",
  },
  {
    url: "/home/all-laboratory-requests",
    module: "LABORATORY",
    name: "All Upcoming Requests",
  },
  {
    url: "/home/pharmacy-overview",
    module: "PHARMACY",
    name: "Pharmacy Overview",
  },
  {
    url: "/home/pharmacy-stock-management",
    module: "PHARMACY",
    name: "Pharmacy Stock Mgt.",
  },
  {
    url: "/home/pharmacy-requisition-history",
    module: "PHARMACY",
    name: "Pharmacy Requisition History",
  },
  {
    url: "/home/pharmacy/dashboard/dispensed-request",
    module: "PHARMACY",
    name: "Pharmacy Dashboard Dispense Requests",
  },
  {
    url: "/home/pharmacy/dashboard/expired-drugs",
    module: "PHARMACY",
    name: "Pharmacy Dashboard Expired Drugs",
  },
  {
    url: "/home/inventory-overview",
    module: "INVENTORY",
    name: "Inventory Overview",
  },
  {
    url: "/home/inventory-purchase-order",
    module: "INVENTORY",
    name: "Inventory Purchase Order",
  },
  {
    url: "/home/inventory-stock-management",
    module: "INVENTORY",
    name: "Inventory Stock Mgt.",
  },
  {
    url: "/home/inventory-cost",
    module: "INVENTORY",
    name: "Inventory Cost",
  },
  {
    url: "/home/inventory-items",
    module: "INVENTORY",
    name: "Inventory Items",
  },
  {
    url: "/home/inventory/requisition-history",
    module: "INVENTORY",
    name: "Inventory Requisition History",
  },
  {
    url: "/home/inventory/vendor-management",
    module: "INVENTORY",
    name: "Inventory Vendor Mgt.",
  },
  {
    url: "/home/accounting-overview",
    module: "ACCOUNTING",
    name: "Accounting Overview",
  },
  {
    url: "/home/accounting/Requisition-dispute",
    module: "ACCOUNTING",
    name: "Accounting Requisition Dispute",
  },
  {
    url: "/home/accounting/requisitions",
    module: "ACCOUNTING",
    name: "Accounting Requisitions",
  },
  {
    url: "/home/accounting-dispute-list",
    module: "ACCOUNTING",
    name: "Accounting Dispute List",
  },
  {
    url: "/home/accounting-open-dispute",
    module: "ACCOUNTING",
    name: "Accounting Open Dispute",
  },
  {
    url: "/home/accounting/report",
    module: "ACCOUNTING",
    name: "Accounting Report",
  },
  {
    url: "/home/accounting/transaction-types",
    module: "ACCOUNTING",
    name: "Accounting Transaction Types",
  },

  {
    url: "/home/settings-permission",
    module: "SETTINGS",
    name: "User Roles And Permissions",
  },

  {
    url: "/home/settings-more",
    module: "SETTINGS",
    name: "More",
  },

  {
    url: "/home/radiology-overview",
    module: "RADIOLOGY",
    name: "Radiology Overview",
  },
  {
    url: "/home/radiology-stock-management",
    module: "RADIOLOGY",
    name: "Radiology Stock Mangement",
  },
  {
    url: "/home/radiology-test-center",
    module: "RADIOLOGY",
    name: "Radiology Test Center",
  },
  {
    url: "/home/all-radiology-requests",
    module: "RADIOLOGY",
    name: "All Radiology Upcoming Requests",
  },

  // {
  //   url: "/home/profile",
  //   module: "profile",
  // },
];
